/**
 * @generated SignedSource<<f10702cfc680fb92992ef636f8d5417f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type AddOrReplacePlayerPrivateStep_Booking$data = {
  readonly __typename: string;
  readonly startSlot: {
    readonly __typename: "QueueSlot";
    readonly agenda: {
      readonly facility: {
        readonly type: FacilityType;
      };
    };
    readonly club: {
      readonly id: string;
    };
    readonly course?: {
      readonly courseLayouts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly code: string;
            readonly holeCount: HoleCount;
            readonly id: string;
            readonly name: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly defaultCourseLayout: {
        readonly holeCount: HoleCount;
        readonly id: string;
      } | null | undefined;
      readonly id: string;
      readonly name: string;
    };
    readonly requirePlayerCounts?: boolean;
    readonly standardCapacity?: number;
    readonly usedCapacity?: number;
    readonly " $fragmentSpreads": FragmentRefs<"AddNewPlayersHeaderNode">;
  } | null | undefined;
  readonly type: BookingType;
  readonly " $fragmentType": "AddOrReplacePlayerPrivateStep_Booking";
};
export type AddOrReplacePlayerPrivateStep_Booking$key = {
  readonly " $data"?: AddOrReplacePlayerPrivateStep_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddOrReplacePlayerPrivateStep_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "AddNewPlayersHeaderNode"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeCount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddOrReplacePlayerPrivateStep_Booking",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v2/*: any*/),
            {
              "alias": "standardCapacity",
              "args": [
                {
                  "kind": "Literal",
                  "name": "bookingType",
                  "value": "STANDARD"
                }
              ],
              "kind": "ScalarField",
              "name": "capacity",
              "storageKey": "capacity(bookingType:\"STANDARD\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "usedCapacity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requirePlayerCounts",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayout",
                  "kind": "LinkedField",
                  "name": "defaultCourseLayout",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v5/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayoutConnection",
                  "kind": "LinkedField",
                  "name": "courseLayouts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayoutEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseLayout",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "code",
                              "storageKey": null
                            },
                            (v5/*: any*/),
                            (v4/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "type": "QueueSlot",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "506a7d81b752ecc3a7d39c9ee738a73e";

export default node;
